<template>
  <div class="pages">
    <div class="extractLogin">
      <img src="../../assets/img/cloudLogo.png" alt />
      <p>请输入手机号提取：</p>
      <div class="inputDiv">
        <div class="inputBg">
          <input type="text" placeholder="请输入手机号" @change="getPhone" @keyup.enter="extract" />
        </div>
        <div class="moniBtn" @click="extract">提取作品</div>
      </div>
    </div>
  </div>
</template>

<script>
import { obtain } from "@/request/api";
import { Message } from "element-ui";

export default {
  name: "customerLogin",
  data() {
    return {
      phoneValue: ""
    };
  },
  methods: {
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 获取手机号
    getPhone(event) {
      this.phoneValue = event.srcElement.value;
    },
    // 点击提取
    extract() {
      console.log('1111')
      var that = this;
      var params = {
        code: that.phoneValue
      };
      obtain(params).then(res => {
        console.log(res, "登录成功");
        if (res.data.data.length != 0) {
          that.$router.push({
            path: "/clientHome",
            query: {
              id: that.phoneValue
            }
          });
        } else {
          Message.error("该手机号没有绑定项目，请修改手机号");
        }
      });
    }
  },
  mounted() {
    console.log(this._isMobile);
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.push({
        path: "/mobileLogin"
      });
    } else {
      // alert("pc端");
    }
  }
};
</script>

<style lang="less" scoped>
.pages {
  width: 100vw;
  height: 100vh;
  background-image: url(../../assets/img/loginBack.jpg);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .extractLogin {
    width: 530px;
    height:255px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 3px 3px 11px 0px rgba(182, 182, 182, 0.14);
    text-align: center;
    padding: 0px 40px;
    box-sizing: border-box;
    img {
      margin-top: 30px;
      margin-bottom: 46px;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: left;
    }
    .inputDiv {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .inputBg {
        width: 325px;
        height: 35px;
        background: #f6f6f6;
        border-radius: 22px;
        text-align: left;
        line-height: 35px;
        padding-left: 22px;
        box-sizing: border-box;
        input {
          background: #f6f6f6;
          border: none;
        }
        input:focus {
          outline: none;
        }
        input::-webkit-input-placeholder {
          color: #c9c9c9;
          font-size: 14px;
        }
      }
      .moniBtn {
        width: 110px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        border-radius: 22px;
        color: #ffffff;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        background: #000;
      }
    }
  }
}
</style>